import { render, staticRenderFns } from "./DowningTemplate.vue?vue&type=template&id=79fdba66&scoped=true"
import script from "./DowningTemplate.vue?vue&type=script&lang=js"
export * from "./DowningTemplate.vue?vue&type=script&lang=js"
import style0 from "./DowningTemplate.vue?vue&type=style&index=0&id=79fdba66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fdba66",
  null
  
)

export default component.exports